/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  ctaText ? : string;
  ctaTextColor ? : number;
  buttonColor ? : number;
  borderColor ? : number;
  pdfLinkInDam ? : Asset;
  showCtaAsPdf ? : boolean;
}
export interface slidesStruct {
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  title ? : string;
  titleColor ? : number;
  subText ? : string;
  subTextColor ? : number;
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  ctaLink ? : Array < ctaLinkStruct > ;
}
export default interface TwoCT {
  slides ? : Array < slidesStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  slides: Array as() => Array < slidesStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  slides: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class TwoCTBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class TwoCTInstance implements TwoCT {
      slides ? : Array < slidesStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.slides) {
          this.slides = Object.entries(this.slides)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'slides' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.slides.length; i1++) {
            if (this.slides[i1]) {
              if (typeof this.slides[i1].image === 'object') {
                this.slides[i1].image = {
                  ...this.slides[i1].image,
                  link: this.slides[i1].image['@link'],
                  name: this.slides[i1].image['@name'],
                  path: this.slides[i1].image['@path'],
                };
              } else {
                this.slides[i1].image = null as any;
              }
            }
            if (this.slides[i1]) {
              if (this.slides[i1].mobileAspectRatio) {
                this.slides[i1].mobileAspectRatio = Object.entries(this.slides[i1].mobileAspectRatio)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.slides[i1].mobileAspectRatio = null as any;
              }
            }
            if (this.slides[i1]) {
              if (this.slides[i1].imageLink) {
                this.slides[i1].imageLink = Object.entries(this.slides[i1].imageLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.slides[i1].imageLink.length; i2++) {

                  if (this.slides[i1]) {
                    if (this.slides[i1].imageLink[i2]) {
                      if (this.slides[i1].imageLink[i2].switchable) {
                        if (typeof this.slides[i1].imageLink[i2].switchable.download === 'object') {
                          this.slides[i1].imageLink[i2].switchable.download = {
                            ...this.slides[i1].imageLink[i2].switchable.download,
                            link: this.slides[i1].imageLink[i2].switchable.download['@link'],
                            name: this.slides[i1].imageLink[i2].switchable.download['@name'],
                            path: this.slides[i1].imageLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.slides[i1].imageLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.slides[i1].imageLink = null as any;
              }
            }
            if (this.slides[i1]) {
              if (this.slides[i1].ctaLink) {
                this.slides[i1].ctaLink = Object.entries(this.slides[i1].ctaLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.slides[i1].ctaLink.length; i2++) {

                  if (this.slides[i1]) {
                    if (this.slides[i1].ctaLink[i2]) {
                      if (this.slides[i1].ctaLink[i2].switchable) {
                        if (typeof this.slides[i1].ctaLink[i2].switchable.download === 'object') {
                          this.slides[i1].ctaLink[i2].switchable.download = {
                            ...this.slides[i1].ctaLink[i2].switchable.download,
                            link: this.slides[i1].ctaLink[i2].switchable.download['@link'],
                            name: this.slides[i1].ctaLink[i2].switchable.download['@name'],
                            path: this.slides[i1].ctaLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.slides[i1].ctaLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                  if (this.slides[i1]) {
                    if (this.slides[i1].ctaLink[i2]) {
                      if (typeof this.slides[i1].ctaLink[i2].pdfLinkInDam === 'object') {
                        this.slides[i1].ctaLink[i2].pdfLinkInDam = {
                          ...this.slides[i1].ctaLink[i2].pdfLinkInDam,
                          link: this.slides[i1].ctaLink[i2].pdfLinkInDam['@link'],
                          name: this.slides[i1].ctaLink[i2].pdfLinkInDam['@name'],
                          path: this.slides[i1].ctaLink[i2].pdfLinkInDam['@path'],
                        };
                      } else {
                        this.slides[i1].ctaLink[i2].pdfLinkInDam = null as any;
                      }
                    }
                  }
                }
              } else {
                this.slides[i1].ctaLink = null as any;
              }
            }
          }
        } else {
          this.slides = null as any;
        }
      }
    }
    return new TwoCTInstance(props);
  }
}
